import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AttendeesService } from 'src/app/_services/_auth/attendees.service';
import { AuthService } from 'src/app/_services/_auth/auth.service';
import { FogotPasswordDialogComponent } from '../fogot-password-dialog/fogot-password-dialog.component';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private attendeeService: AttendeesService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private formBuilder: FormBuilder
  ) {}

  token: string;
  email: string;
  eventId: string;
  resetPwForm: FormGroup;
  hideNewPw = true;
  hidePwRepeat = true;

  ngOnInit(): void {
    this.route.queryParams.subscribe(async (params) => {
      const token = params.token;
      let valid = false;
      if (token) {
        const data = this.authService.decodedToken(token);
        if (data && data.email && typeof data.email === 'string' && data.eventId && typeof data.eventId === 'string') {
          this.token = token;
          this.email = data.email;
          this.eventId = data.eventId;
          valid = true;
        }
      }
      if (!valid) {
        this.snackBar.open('Invalider Token, bitte fordern sie einen neuen an.', 'Schließen');
        this.dialog.open(FogotPasswordDialogComponent);
      }

      this.resetPwForm = this.formBuilder.group(
        {
          newPassword: new FormControl('', [
            Validators.required,
            Validators.minLength(12),
            Validators.pattern(/\d/),
            Validators.pattern(/[A-Z]/),
            Validators.pattern(/[a-z]/)
          ]),
          newPasswordRepeat: new FormControl('', Validators.required)
        },
        { validators: this.passwordsMustMatch }
      );
    });
  }

  async resetPw() {
    try {
      await this.attendeeService.resetPassword(this.resetPwForm.value.newPassword, this.token);
      this.snackBar.open('Ihr Password wurde erfolgreich zurückgesetzt. Sie können sich nun einloggen.', 'Schließen', {
        duration: 5000
      });
      this.router.navigate(['/login']);
    } catch (error) {
      this.snackBar.open(`Ihr Password konnte nicht zurückgesetzt werden: ${error.error.message}`, 'Schließen', {
        duration: 3000
      });
      setTimeout(() => {
        this.router.navigate(['/']);
      }, 3000);
    }
  }

  passwordsMustMatch: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const newPassword = control.get('newPassword');
    const newPasswordRepeat = control.get('newPasswordRepeat');
    if (newPassword && newPassword.value && newPasswordRepeat && newPasswordRepeat.value) {
      return newPassword.value !== newPasswordRepeat.value ? { passwordsMustMatch: true } : null;
    } else {
      return null;
    }
  }
}
